var _path;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgScheduled = function SvgScheduled(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.36 1.44H12V0.16C12 0.072 11.928 0 11.84 0H10.72C10.632 0 10.56 0.072 10.56 0.16V1.44H5.44V0.16C5.44 0.072 5.368 0 5.28 0H4.16C4.072 0 4 0.072 4 0.16V1.44H0.64C0.286 1.44 0 1.726 0 2.08V15.36C0 15.714 0.286 16 0.64 16H15.36C15.714 16 16 15.714 16 15.36V2.08C16 1.726 15.714 1.44 15.36 1.44ZM14.56 14.56H1.44V6.96H14.56V14.56ZM1.44 5.6V2.88H4V3.84C4 3.928 4.072 4 4.16 4H5.28C5.368 4 5.44 3.928 5.44 3.84V2.88H10.56V3.84C10.56 3.928 10.632 4 10.72 4H11.84C11.928 4 12 3.928 12 3.84V2.88H14.56V5.6H1.44Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScheduled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scheduled.0fafc7f8.svg";
export { ForwardRef as ReactComponent };